// Core
import React from 'react';

// Libraries
import { useTheme } from 'styled-components';

// Media
import conveyorImage from '../../media/images/equipment/conveyor.png';

// Hooks
import { useBreakpoint } from '../../hooks/useBreakpoint';

// Components
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../layout/elements/Paragraph';
import {
  Title,
  TitleSize,
  TitleWeight,
} from '../../layout/elements/Title';

// Component
import { EmptyBoxProps } from './EmptyBox.types';
import {
  Element,
  IconContainer,
  Image,
  TextContainer,
} from './EmptyBox.style';

// Types
import { Theme } from '../../types/theme';

function EmptyBox({
  className,
  description,
  icon,
  imgSrc = conveyorImage,
  testId,
  title,
}: EmptyBoxProps): JSX.Element {
  // Dependencies
  const theme: Theme = useTheme();
  const { isXs } = useBreakpoint();

  return (
    <Element
      data-testid={testId}
      className={className}
    >
      {icon ? (
        <IconContainer data-testid="empty-box-icon-container">
          {icon}
        </IconContainer>
      ) : (
        <Image src={imgSrc} alt={title} />
      )}
      <TextContainer>
        {isXs ? (
          <Paragraph
            size={ParagraphSize.lg}
            weight={ParagraphWeight.bold}
            color={theme.color.emptyBox.titleColor}
          >
            {title}
          </Paragraph>
        ) : (
          <Title
            size={TitleSize.xxs}
            weight={TitleWeight.bold}
            color={theme.color.emptyBox.titleColor}
          >
            {title}
          </Title>
        )}
        <Paragraph
          size={isXs ? ParagraphSize.md : ParagraphSize.lg}
          color={theme.color.emptyBox.descriptionColor}
        >
          {description}
        </Paragraph>
      </TextContainer>
    </Element>
  );
}

export { EmptyBox };
